/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Peaks_Info_PathInputs */

const en_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peaks Info Path`)
};

const fr_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemin des pics`)
};

const de_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gipfel-Infopfad`)
};

const it_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percorso informativo sulle cime`)
};

const ru_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информационный путь к вершинам`)
};

const es_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta de información de Peaks`)
};

const zh_cn2_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peaks 信息路径`)
};

const ja_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ピークス情報パス`)
};

const hi_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पीक्स इन्फो पाथ`)
};

const pt_pt2_peaks_info_path = /** @type {(inputs: Peaks_Info_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações sobre os picos`)
};

/**
* | output |
* | --- |
* | "Peaks Info Path" |
*
* @param {Peaks_Info_PathInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const peaks_info_path = /** @type {((inputs?: Peaks_Info_PathInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Peaks_Info_PathInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_peaks_info_path(inputs)
	if (locale === "de") return de_peaks_info_path(inputs)
	if (locale === "it") return it_peaks_info_path(inputs)
	if (locale === "ru") return ru_peaks_info_path(inputs)
	if (locale === "es") return es_peaks_info_path(inputs)
	if (locale === "zh-CN") return zh_cn2_peaks_info_path(inputs)
	if (locale === "ja") return ja_peaks_info_path(inputs)
	if (locale === "hi") return hi_peaks_info_path(inputs)
	if (locale === "pt-PT") return pt_pt2_peaks_info_path(inputs)
	return en_peaks_info_path(inputs)
});